const t = {
  name: "DayNight",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M20,0C9,0,0,9,0,20c0,11,9,20,20,20c11,0,20-9,20-20C40,9,31,0,20,0z M19,2V38C9.5,37.5,2,29.6,2,20
			C2,10.4,9.5,2.5,19,2z M21,38V2c0.6,0,1.2,0.1,1.8,0.2v35.6C22.2,37.9,21.6,37.9,21,38z M26.6,36.8c-0.6,0.2-1.2,0.4-1.8,0.6V2.6
			C25.4,2.8,26,3,26.6,3.2V36.8z M28.6,35.8V4.2c0.6,0.3,1.2,0.7,1.8,1.1v29.4C29.8,35.1,29.2,35.5,28.6,35.8z M34.2,31.1
			c-0.6,0.7-1.2,1.4-1.8,2V7c0.6,0.6,1.2,1.3,1.8,2V31.1z M36.2,27.9V12.1c1.2,2.4,1.8,5,1.8,7.9S37.4,25.5,36.2,27.9z"/>
	</g>
</g>
</svg>
  `
};
export {
  t as DayNight
};
